export const transformRequestGenerateReturnLabel = ({ resourceId, includeRejectedItems, discardLabels }) => {
  return {
    resourceId,
    payload: {
      include_rejected_items: includeRejectedItems,
      discard_previous_labels: !!discardLabels,
    },
  }
}
